import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { getPaymentStatus } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("pending");

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const data = await getPaymentStatus(sessionId);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {
        /* keep polling */
      }
      attempts += 1;
      if (attempts < 8) setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
  }, [sessionId]);

  const content = {
    pending: { icon: <Loader2 className="animate-spin text-[#E2C079]" size={40} />, title: t.payment.pendingTitle, text: t.payment.pendingText },
    paid: { icon: <CheckCircle2 className="text-emerald-400" size={40} />, title: t.payment.successTitle, text: t.payment.successText },
    failed: { icon: <XCircle className="text-red-400" size={40} />, title: t.payment.failedTitle, text: t.payment.failedText },
  }[state];

  return (
    <div className="bg-[#0b131e] min-h-screen flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-md w-full rounded-lg border border-white/10 bg-[#0f1b29] p-10 text-center space-y-4">
        <div className="flex justify-center" data-testid="payment-status-icon">{content.icon}</div>
        <h1 className="font-serif-didot text-2xl text-white" data-testid="payment-status-title">{content.title}</h1>
        <p className="text-sm text-white/60" data-testid="payment-status-text">{content.text}</p>
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-block mt-4 px-6 py-3 border border-[#E2C079] text-[#E2C079] text-xs font-mono-code uppercase tracking-widest hover:bg-[#E2C079] hover:text-[#0b131e] transition-colors"
        >
          {t.payment.back}
        </Link>
      </div>
    </div>
  );
}
